module.exports = __webpack_public_path__ + "static/media/ordkjede.f498f7f6.png";